export default {
  angleDown: "fa-angle-down",
  angleLeft: "fa-angle-left",
  angleRight: "fa-angle-right",
  angleUp: "fa-angle-up",
  book: "fa-book",
  calendarHollow: "fa-calendar-o",
  checkmark: "fa-check",
  heart: "fa-heart",
  history: "fa-history",
  key: "fa-key",
  search: "fa-search",
  timesCircle: "fa-times-circle"
};
